import { APPLICANT_STAGE } from '../../../RentalPortalApplicant'

export function getIsApplicantInPool(applicantData) {
  return applicantData?.stage === APPLICANT_STAGE.pool
}
